import { useEffect } from "react";

/**
 * Renders nothing — flips window.location to the static HTML legal document
 * served from /legal/. Lives outside React's BrowserRouter scope so the
 * deep-link to /privacy or /terms from search engines lands cleanly on the
 * canonical PrivacyLens-authored copy.
 */
export default function LegalRedirect({ slug }) {
  useEffect(() => {
    window.location.replace(`/legal/${slug}.html`);
  }, [slug]);
  return (
    <div
      className="min-h-screen grid place-items-center bg-[#0A0A0A] text-white"
      data-testid={`legal-redirect-${slug}`}
    >
      <div className="font-mono text-xs uppercase tracking-widest text-white/60">
        Loading {slug}…
      </div>
    </div>
  );
}
